import { DateInputField, DateInputOptions } from "./form-field/date-input";
import { TextInputField, TextInputOptions } from "./form-field/text-input";
import { DropdownInputField, DropdownInputOptions } from "./form-field/dropdown-input";
import { FileUploadInputField, FileUploadInputOptions } from "./form-field/file-upload";
import { NumberInputField, NumberInputOptions } from "./form-field/number-input";
import { MultiAddInputField, MultiAddInputOptions } from "./form-field/multi-add-input";
import { PickListItem, JsonItem } from "../../entities/pick-list/pick-list.entities";
import { WebForm, WebFormConfig } from "./web-form";
import { YesNoInputField, YesNoInputOptions } from "./form-field/yes-no-input";
import { NestedFormInputField, NestedFormInputOptions } from "./form-field/nested-form-input";

export {
    DateInputField, DateInputOptions,
    TextInputField, TextInputOptions,
    DropdownInputField, DropdownInputOptions,
    FileUploadInputField, FileUploadInputOptions,
    NumberInputField, NumberInputOptions,
    MultiAddInputField, MultiAddInputOptions,
    PickListItem, JsonItem,
    WebForm, WebFormConfig,
    YesNoInputField, YesNoInputOptions,
    NestedFormInputField, NestedFormInputOptions
}

export interface IFormField {
    fieldId: string; // Id of HTML element/block
    displayName: string; // Display label
    description: string; // Description of field
    isRequired: boolean;
    propertyName: string; // property name of data element (dot notation)
    defaultVal: any; // used if no value or invalid
    initialVal: any; // used while editing

    initialize(): void; // initializes field (sets up change trigger)
    generateHtml(): string; // returns the html
    setOptions(pickLists: JsonItem[]): void; // sets dropdown options (or does nothing for some fields)
    getValue(): any; // get current value of form field
    prepopulate(items: any[]): void; // prepopulates the field
    updateItem(item: any): any; // Updates item with current field value, returns updated item (forceVal is optional)
    setValue(data: any): void; // force set a value
    checkChanged(): boolean; // check if current val is different default val;
    checkValid(): boolean; // is input valid;
    displayValid(isValid: boolean): void; // update display for if entry if valid or not
    resetValidDisplay() : void; // reset any display validation
    generateChangeHtml(newItem: any, prevItem: any): string; // generates html showing changes
    compareItems(item1: any, item2: any): boolean; // determines if two items have the same value for field property
}

export class FormSection {
    sectionId: string;
    displayName: string;
    formFields: IFormField[];

    constructor(config: FormSectionConfig) {
        this.sectionId = config.sectionId;
        this.displayName = config.displayName;
        this.formFields = config.formFields;
    }

    initialize(pickLists: JsonItem[]) {
        this.formFields.forEach(field => {
            field.setOptions(pickLists);
            field.initialize();
        });
    }

    getSectionStatus(): SectionStatus {
        let isValid = this.formFields.every(field => field.checkValid());
        if (isValid) return SectionStatus.Complete;

        /*let isInProgress = this.formFields.some(field => field.checkChanged());
        if (isInProgress) return SectionStatus.InProgress;*/

        let isSomeValues = this.formFields.filter(field => field.isRequired).some(field => field.checkValid());
        if (isSomeValues) return SectionStatus.InProgress;

        return SectionStatus.NotStarted;
    }
}

export class FormSectionConfig {
    sectionId: string;
    displayName: string;
    formFields: IFormField[];
}

export enum SectionStatus {
    "NotStarted",
    "InProgress",
    "Complete"
}


// Documents
export class DocumentInfoV2 {
    id: string;
    parent: string;
    text: string;
    icon: string;
    link: string;
    type: number;
    state: any;
    lastModified: Date;

    constructor() {

    }
}
export function getFileIcon(fileType: string) {

    if (fileType.includes("image")) return `<i class="fas fa-file-image expand-btn"></i>`;
    if (fileType.includes("pdf")) return `<i class="fa-solid fa-file-pdf expand-btn"></i>`;
    if (fileType.includes("word")) return `<i class="fa-solid fa-file-word expand-btn"></i>`;
    if (fileType.includes("spreadsheet")) return `<i class="fa-solid fa-file-excel expand-btn"></i>`;
    if (fileType.includes("presentation")) return `<i class="fa-solid fa-file-powerpoint expand-btn"></i>`;
    if (fileType.includes("audio")) return `<i class="fa-solid fa-file-audio expand-btn"></i>`;
    if (fileType.includes("video")) return `<i class="fa-solid fa-file-video expand-btn"></i>`;
    if (fileType.includes("csv")) return `<i class="fa-solid fa-file-csv expand-btn"></i>`;

    return `<i class="fa-solid fa-file expand-btn"></i>`
}